import { types } from '../../types';

const setGetCreditHistoryAction = (payload) => {
  return {
    type: types.credit.SET_LIST_CREDIT_HISTORY,
    payload,
  }
}

export {
  setGetCreditHistoryAction as SetGetCreditHistoryAction
}
